import { AppRole } from '@core/enums/rol.enum';

export const ROUTE_ROLES: Record<string, AppRole[]> = {
  'perfil-usuario': [AppRole.CONFIGURAR_PERFIL],
  'perfil-usuario/editar': [AppRole.CONFIGURAR_PERFIL],
  'perfil-usuario/editar-direccion': [AppRole.CONFIGURAR_PERFIL],
  'perfil-usuario/editar-contacto-alterno': [AppRole.CONFIGURAR_PERFIL],
  'perfil-usuario/editar-config-debito': [AppRole.CONFIGURAR_PERFIL],
  'metodo-pago': [
    AppRole.CREAR_METODO_PAGO,
    AppRole.CONSULTAR_METODO_PAGO,
    AppRole.MODIFICAR_METODO_PAGO,
  ],
  dashboard: [AppRole.CONSULTAR_BALANCE_AHORROS],
  'realizar-aporte': [AppRole.REALIZAR_APORTE_EXTRAORDINARIO],
  'retirar-aporte': [AppRole.SOLICITAR_RETIRO],
  'calcular-objetivo-ahorro': [AppRole.SIMULAR_OBJETIVO_AHORRO],
  'consultar-estado-cuenta': [AppRole.CONSULTAR_ESTADO_CUENTA],
  'mis-objetivos-ahorro': [AppRole.CONSULTAR_OBJETIVO_AHORRO],
  'objetivo-ahorro/:id': [
    AppRole.CONSULTAR_OBJETIVO_AHORRO,
    AppRole.CONSULTAR_MOVIMIENTOS_OBJETIVO_AHORRO,
  ],
  'crear-objetivo': [AppRole.DEFINIR_OBJETIVO_AHORRO],
  'modificar-objetivo/:id': [AppRole.MODIFICAR_OBJETIVO_AHORRO],
  'cambiar-password': [AppRole.CAMBIAR_CLAVE],
};